"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _native2 = _interopRequireDefault(require("../templates/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var _prepareDynamicChildren = _interopRequireDefault(require("../../../utils/prepareDynamicChildren"));

var _constants = require("../constants");

var _selectRender = _interopRequireDefault(require("../utils/selectRender"));

var _listRender = _interopRequireDefault(require("../utils/listRender"));

var _react = _interopRequireDefault(require("react"));

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", function () {
      return _this.props["native"] ? _native2["default"].call((0, _assertThisInitialized2["default"])(_this)) : _main["default"].call((0, _assertThisInitialized2["default"])(_this));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var _this$props, readOnly, disabled, focusListOnOpen, onOpen, list;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, readOnly = _this$props.readOnly, disabled = _this$props.disabled, focusListOnOpen = _this$props.focusListOnOpen, onOpen = _this$props.onOpen, list = _this.state.list;

              if (!(readOnly || disabled)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", Promise.resolve());

            case 3:
              if (!(list && list.length)) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return _this.setState({
                active: true
              });

            case 6:
              if (focusListOnOpen) {
                _this.focusList();
              }

              if (typeof onOpen === 'function') {
                onOpen();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "select",
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(value) {
        var _this$state$list, _this$value2;

        var multiple, _this$value, next;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                multiple = _this.props.multiple;

                if (multiple) {
                  next = Array.isArray(_this.value) ? (0, _toConsumableArray2["default"])(_this.value) : [];

                  if ((_this$value = _this.value) === null || _this$value === void 0 ? void 0 : _this$value.includes(value)) {
                    next = next.filter(function (item) {
                      return item !== value;
                    });
                  } else {
                    next.push(value);
                  }

                  _this.value = next;
                } else {
                  _this.value = value;
                }

                if (!(!multiple || multiple && ((_this$state$list = _this.state.list) === null || _this$state$list === void 0 ? void 0 : _this$state$list.length) === ((_this$value2 = _this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.length))) {
                  _context2.next = 6;
                  break;
                }

                // mouseLeave не срабатывает после выбора значения из списка
                _this._handleRootBlur();

                _context2.next = 6;
                return _this.close();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleNativeSelectChange", function (event) {
      var selected = Array.prototype.find.call(event.target.children, function (option) {
        return option.value === event.target.value;
      });

      if (selected) {
        _this.select(selected.id);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                active: false
              });

            case 2:
              if (typeof _this.props.onClose === 'function') {
                _this.props.onClose();
              }

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusList", function () {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.LIST_ITEM_POSITION_FIRST;

      var next = _this._findFirstFocusableElement(position === _constants.LIST_ITEM_POSITION_FIRST ? 1 : -1);

      if (next && typeof next.focus === 'function') {
        next.focus();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleBlur", function (event) {
      var _this$root;

      // блюр срабатывает так же при выборе элемента из списка, в таком случае нам не нужна обработка введенных в инпут данных
      if (event.relatedTarget && !((_this$root = _this.root) === null || _this$root === void 0 ? void 0 : _this$root.contains(event.relatedTarget))) {
        _this.close();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_keymap", function (event) {
      if (event.key === _constants.KEY_ARROW_DOWN || event.key === _constants.KEY_ARROW_UP) {
        event.preventDefault();

        var next = _this._findFirstFocusableElement(event.key === _constants.KEY_ARROW_DOWN ? 1 : -1);

        if (next && typeof next.focus === 'function') {
          next.focus();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleHover", function () {
      if (!_this.state.hover) {
        _this.setState({
          hover: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRootBlur", function () {
      if (_this.state.hover) {
        _this.setState({
          hover: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rootRef", function (el) {
      _this.root = el;

      _this._externalRef((0, _assertThisInitialized2["default"])(_this));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_externalRef", function (el) {
      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }
    });
    var collection = props.collection ? _this._processCollection(props.collection) : props.children;
    _this.state = {
      active: false,
      hover: false,
      list: (0, _prepareDynamicChildren["default"])(collection)
    };
    _this.nativeElement = _react["default"].createRef();
    _this.listElement = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(prevProps, prevState) {
        var _this$props2, children, collection, value, onListChange, multiple, list, selected, hasRedundantValue;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props2 = this.props, children = _this$props2.children, collection = _this$props2.collection, value = _this$props2.value, onListChange = _this$props2.onListChange, multiple = _this$props2.multiple;

                if (!(collection !== prevProps.collection || children !== prevProps.children)) {
                  _context4.next = 9;
                  break;
                }

                list = collection ? this._processCollection(collection) : children;
                _context4.next = 5;
                return this.setState({
                  list: (0, _prepareDynamicChildren["default"])(list)
                });

              case 5:
                selected = this._getSelected();

                if (value !== null && value !== undefined && value !== '' && !selected) {
                  this.value = null;
                }

                if (multiple && selected && Array.isArray(value)) {
                  hasRedundantValue = value.find(function (id) {
                    return !selected.find(function (item) {
                      return item.id === id;
                    });
                  });

                  if (hasRedundantValue) {
                    this.value = selected.map(function (item) {
                      return item.id;
                    });
                  }
                }

                if (typeof onListChange === 'function') {
                  onListChange(this.state.list);
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "_getSelected",
    value: function _getSelected() {
      var _this2 = this;

      var list = this.state.list,
          _this$props3 = this.props,
          multiple = _this$props3.multiple,
          value = _this$props3.value;

      if (value && list) {
        if (multiple && Array.isArray(value)) {
          var selected = list.filter(function (item) {
            return value.includes(item.id);
          });
          return selected.length ? selected : null;
        } else {
          // без точного приведения типов, потому что в модель может записаться стринг после ввода через инпут
          return list.find(function (item) {
            return _this2.props.value == item.id;
          });
        }
      } else {
        return null;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      return this.nativeElement.current && this.nativeElement.current.focus();
    } // смена фокусу через Tab на другой элемент на странице при открытом списке

  }, {
    key: "_findFirstFocusableElement",
    // dont work with virtualized list, because of dynamic children, rendered by react-tiny-virtual-list
    value: function _findFirstFocusableElement(increment) {
      var _this$listElement$cur;

      var list = (_this$listElement$cur = this.listElement.current) === null || _this$listElement$cur === void 0 ? void 0 : _this$listElement$cur.children;
      var result = null;

      if (list instanceof HTMLCollection || Array.isArray(list)) {
        var iterable = (0, _toConsumableArray2["default"])(list);
        var breakpoint = iterable.find(function (node) {
          return window.document.activeElement === node;
        });

        if (breakpoint) {
          var breakpointIndex = iterable.indexOf(breakpoint),
              head = iterable.slice(0, breakpointIndex),
              tail = iterable.slice(breakpointIndex + 1);
          iterable = increment < 0 ? [].concat(head.reverse(), tail.reverse()) : [].concat(tail, head);
        } else {
          iterable = increment < 0 ? iterable.reverse() : iterable;
        }

        result = iterable.find(function (option) {
          return option instanceof HTMLButtonElement;
        });
      }

      return result;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Main.prototype), "componentWillUnmount", this).call(this);

      this._externalRef(null);
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    },
    set: function set(value) {
      var target = {
        value: value,
        name: this.props.name,
        type: 'select'
      };

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target));
      }
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  maxLength: 12,
  emptyListPlaceholder: 'DROP_EMPTY_LIST',
  placeholder: 'DROP_DEFAULT',
  inline: false,
  cropLabel: false,
  focusListOnOpen: true,
  selectRender: _selectRender["default"],
  listRender: _listRender["default"],
  virtualized: false,
  "native": false,
  multiple: false,
  multipleSeparator: ', '
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  /**
   * max length of list
   */
  maxLength: _propTypes["default"].number,

  /**
   * placeholder for empty drop list
   */
  emptyListPlaceholder: _propTypes["default"].string,

  /**
   * components label
   */
  label: _propTypes["default"].string,

  /**
   * components placeholder
   */
  placeholder: _propTypes["default"].string,

  /**
   * processor fn
   */
  processor: _propTypes["default"].func,

  /**
   * called when list close
   */
  onClose: _propTypes["default"].func,

  /**
   * called when list open
   */
  onOpen: _propTypes["default"].func,

  /**
   * onChange callback
   */
  onChange: _propTypes["default"].func,

  /**
   * inline style
   */
  inline: _propTypes["default"].bool,
  collection: _propTypes["default"].any,
  cropLabel: _propTypes["default"].bool,
  selectRender: _propTypes["default"].func,
  listRender: _propTypes["default"].func,
  focusListOnOpen: _propTypes["default"].bool,
  virtualized: _propTypes["default"].bool,
  "native": _propTypes["default"].bool,
  error: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default DropDown
     */
    appearance: _propTypes["default"].func,

    /**
     * @default block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.fontFamily
     */
    fontFamily: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default palette.gutter + 'px'
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default palette.elPrimary
     */
    listBackground: _propTypes["default"].string,

    /**
     * @default 0 6px 10px 0 ${palette.elShadow}, 0 4px 10px 0 ${palette.elShadow}
     */
    listBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    listZIndex: _propTypes["default"].number,

    /**
     * @default auto
     */
    listOverflowY: _propTypes["default"].string,

    /**
     * @default auto
     */
    listOverflowX: _propTypes["default"].string,

    /**
     * @default auto
     */
    listMaxHeight: _propTypes["default"].string,

    /**
     * @default top
     */
    listTransformOrigin: _propTypes["default"].string,

    /**
     * @default 100%
     */
    listMinWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default palette.tActive
     */
    listItemColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    listItemBackground: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    listItemPaddingLeft: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    listItemPaddingRight: _propTypes["default"].string,

    /**
     * @description equal to selector padding by default
     * @default undefined
     */
    listItemPaddingTop: _propTypes["default"].any,

    /**
     * @default undefined
     */
    listItemPaddingBottom: _propTypes["default"].any,

    /**
     * @default 0 none
     */
    listItemBorderTop: _propTypes["default"].string,

    /**
     * @default 0 none
     */
    listItemBorderBottom: _propTypes["default"].string,

    /**
     * @default 0 none
     */
    listItemBorderLeft: _propTypes["default"].string,

    /**
     * @default 0 none
     */
    listItemBorderRight: _propTypes["default"].string,

    /**
     * @default 0 none
     */
    listItemBorder: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    listItemHoverBackground: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    listItemHoverColor: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    listItemFocusColor: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    listItemFocusBackground: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    listItemSelectedColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    listItemSelectedBackground: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    listItemFocusSelectedColor: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    listItemFocusSelectedBackground: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    listItemHoverSelectedColor: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    listItemHoverSelectedBackground: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    idleColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    idlePlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    idleLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    idleBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    idleBorderStyle: _propTypes["default"].string,

    /**
     * @default 1px
     */
    idleBorderWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default scaleX(0)
     */
    idleBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    idleBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    idleBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    idleBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    idleOutline: _propTypes["default"].string,

    /**
     * @default 0.38
     */
    idleAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.tActive
     */
    focusColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    focusPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    focusLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    focusBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    focusBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    focusBorderWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default scaleX(1)
     */
    focusBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    focusBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    focusBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    focusBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    focusOutline: _propTypes["default"].string,

    /**
     * @default 0.87
     */
    focusAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    hoverPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    hoverLabelColor: _propTypes["default"].string,

    /**
     * @default palette.elSecondary
     */
    hoverBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    hoverBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    hoverBorderWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default scaleX(1)
     */
    hoverBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    hoverBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverOutline: _propTypes["default"].string,

    /**
     * @default 0.87
     */
    hoverAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    disabledLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tPlaceholder
     */
    disabledPlaceholder: _propTypes["default"].string,

    /**
     * @default scaleX(1)
     */
    disabledBorderTransform: _propTypes["default"].string,

    /**
     * @default none none dotted
     */
    disabledBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    disabledBorderWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default palette.elDivider
     */
    disabledBorderColor: _propTypes["default"].string,

    /**
     * @default 0
     */
    disabledBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    disabledBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    disabledBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    disabledOutline: _propTypes["default"].string,

    /**
     * @default 0.15
     */
    disabledAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.tFilled
     */
    errorColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default palette.tHint
     */
    errorPlaceholder: _propTypes["default"].string,

    /**
     * @default palette.elError
     */
    errorBorderColor: _propTypes["default"].string,

    /**
     * @default none none solid
     */
    errorBorderStyle: _propTypes["default"].string,

    /**
     * @default 2px
     */
    errorBorderWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * @default scaleX(1)
     */
    errorBorderTransform: _propTypes["default"].string,

    /**
     * @default 0
     */
    errorBorderRadius: _propTypes["default"].string,

    /**
     * @default transparent
     */
    errorBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    errorBoxShadow: _propTypes["default"].string,

    /**
     * @default none
     */
    errorOutline: _propTypes["default"].string
  }),

  /**
   * callback for processed list changing
   */
  onListChange: _propTypes["default"].func,
  multiple: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
  multipleSeparator: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Main, "displayName", 'DropDown');
var _default = Main;
exports["default"] = _default;